import React, { useState, useEffect, useRef } from 'react';
import { Typography, TextField, Checkbox, Modal, Box, Button, CircularProgress, Alert, FormHelperText } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as CONSTANTS from "../../../StringConstants.js"
import TLHClassesAPICalls from 'services/TLHClassesAPICalls.js';
import { South } from '@mui/icons-material';

export default function CreateNewClassModel({handleClose}) {

  const [tlhLessons, setTlhLessons] = useState()
  const [tlhOneToOneLessons, setTlhOneToOneLessons] = useState([])
  const [isLoadingLessons, setIsLoadingLessons] = useState(true)
  const [lessonsError, setLessonsError] = useState('')
  const [accountCheckModal, setAccountCheckModal] = useState({
    open: false,
    email: '',
    loading: false,
    status: null, // EXISTING_LINKED | WORKSPACE_FOUND_UNLINKED | WORKSPACE_TAKEN | NO_ACCOUNT
  })

  const eitherRequired = (other) =>
  yup
    .string()
    .trim()
    .when(['classType', other], {
      is: (classType, otherVal) =>
        classType === 'one_to_one' && !(otherVal && otherVal.trim()),
      then: (s) => s.required('Provide either TLH student or New Enquiry student'),
      otherwise: (s) => s.notRequired(),
    });

  const validationSchema = yup.object({
    className: yup.string().notRequired(),
    classStartDate: yup.string().when('classType', {
      is: 'one_to_one',
      then: yup.string().nullable(),
      otherwise: yup.string().required('Class Start Date is required'),
    }),
    classType: yup
      .string()
      .required('Class Type is required'),
    startTime: yup.date().nullable().when('classType', {
      is: 'one_to_one',
      then: yup.date().nullable(),
      otherwise: yup.date().required('Start Time is required'),
    }),
    subject: yup
      .string()
      .required('Subject is required'),
    roomNumber: yup
      .string()
      .required('Room Number is required'),
    yearGroup: yup
      .string()
      .required('Year Group is required'),
    // lessonFrequency: yup.number().when('classType', {
    //   is: 'one_to_one',
    //   then: yup.number().required('How often will the class run - e.g every 7 days, every 1 day...'),
    //   otherwise: yup.number().nullable()
    // }),
    classEndDate: yup.date().when('classType', {
        is: (classType) => classType === 'holiday_workshop' || classType === 'booster_class',
        then: yup.date().required('Class End Date is required'),
        otherwise: yup.date().nullable()
      }),
    // numHoursBooked: yup.date().when('classType', {
    //     is: 'one_to_one',
    //     then: yup.date().required('Number of booked hours is required for 1 to 1'),
    //     otherwise: yup.date().nullable()
    //   }),
    tlhStudentName: yup.string().when('classType', {
      is: 'one_to_one',
      then: eitherRequired('studentName'),
      otherwise: yup.string().notRequired()
    }),
    studentName: yup.string().when('classType', {
      is: 'one_to_one',
      then: eitherRequired('tlhStudentName'),
      otherwise: yup.string().notRequired()
    }),
  });

  useEffect(() => {
    if (isLoadingLessons) {
      getAllTLHLessons()
    }
  }, [isLoadingLessons]);

  function getAllTLHLessons() {
    Promise.all([
      TLHClassesAPICalls.getAllTLHLessons(),
      TLHClassesAPICalls.getAllTLHOneToOneLessons(),
    ]).then(([lessonsResult, oneToOneResult]) => {
      console.log("Lessons")
      console.log(lessonsResult.data)
      setTlhLessons(lessonsResult.data)
      setTlhOneToOneLessons(oneToOneResult.data || [])
      setIsLoadingLessons(false)
    })
  }


  function getExpectedEmail(fullName) {
    const parts = fullName.trim().split(' ');
    const first = parts[0]?.toLowerCase() || '';
    const surnameInitial = parts[parts.length > 1 ? parts.length - 1 : 0]?.[0]?.toLowerCase() || '';
    return `${first}${surnameInitial}@vhwhizzkids.com`;
  }

  async function handleOnlineAccountCheck(values) {
    const studentName = values.studentName || values.tlhStudentName || '';
    const nameParts = studentName.trim().split(' ');
    const firstName = nameParts[0] || '';
    const surname = nameParts.slice(1).join(' ') || '';
    const expectedEmail = getExpectedEmail(studentName);
    const tlhStudentId = values.oneToOneCurrentTLHStudentId || null;

    setAccountCheckModal({ open: true, email: expectedEmail, loading: true, status: null });

    try {
      const res = await TLHClassesAPICalls.checkStudentOnlineAccount(firstName, surname, tlhStudentId);
      const { email, status } = res.data;
      console.log('[OnlineAccountCheck] response:', res.data);
      console.log(`[OnlineAccountCheck] status: ${status}`);

      // For all statuses except WORKSPACE_TAKEN, proceed directly without showing a modal
      if (status !== 'WORKSPACE_TAKEN') {
        console.log('[OnlineAccountCheck] Proceeding directly to class creation');
        setAccountCheckModal(m => ({ ...m, open: false }));
        formik.submitForm();
        return;
      }

      // WORKSPACE_TAKEN — inform the user a new account will be created, then proceed on confirmation
      console.log('[OnlineAccountCheck] WORKSPACE_TAKEN — informing user a new account will be created');
      setAccountCheckModal({ open: true, email: email || expectedEmail, loading: false, status });
    } catch (err) {
      console.error('[OnlineAccountCheck] Failed to check online account:', err);
      // On error, proceed anyway — backend handles account creation
      setAccountCheckModal(m => ({ ...m, open: false }));
      formik.submitForm();
    }
  }

  const formik = useFormik({
    initialValues: {
      classStartDate: '',
      classEndDate: '',
      startTime: '',
      className: '',
      classDurationMins: 60,
      subject: '',
      roomNumber: '',
      yearGroup: '',
      // dayOfTheWeek: '',
      classType: '',
      // numHoursBooked: '',
      // lessonFrequency: '',
      relatedClasses: [],
      duplicateClasses: [], 
      lessons: [],
      studentName: '',
      tlhStudentName: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("Submitting new class form")
      console.log("formik values")
      console.log(values)
      
      // Auto-generate class name from student name and subject
      const studentName = values.studentName || values.tlhStudentName || '';
      values.className = `${studentName} - ${values.subject.toUpperCase()}`;

      // Set classStartDate to the earliest lesson date
      if (values.lessons && values.lessons.length > 0) {
        const earliestDate = values.lessons
          .map(lesson => lesson.date)
          .filter(date => date)
          .sort()[0];
        if (earliestDate) {
          values.classStartDate = earliestDate;
        }
      }

      // If classEndDate is null or empty, set it to the latest lesson date
      if ((!values.classEndDate || values.classEndDate.trim() === '') && 
          values.lessons && values.lessons.length > 0) {
        const latestDate = values.lessons
          .map(lesson => lesson.date)
          .filter(date => date)
          .sort()
          .pop();
        if (latestDate) {
          values.classEndDate = latestDate;
        }
      }

      // If startTime is null or empty, set it to the start time of the first lesson
      if ((!values.startTime || values.startTime === '') && 
          values.lessons && values.lessons.length > 0 && 
          values.lessons[0].time) {
        values.startTime = values.lessons[0].time;
      }
      
      TLHClassesAPICalls.createClassFromTLHClassesDashboard(values)
        .then(() => handleClose(false))
        .catch((error) => {
          if (error.response?.status === 400 && error.response?.data === 'NO_LESSONS_ADDED') {
            setLessonsError('Please add at least one lesson before creating the class.');
          } else {
            handleClose(false);
          }
        });
    },
  });


  return (


    <div>
      {isLoadingLessons ? <></> : 
      <form
          onSubmit={formik.handleSubmit}
      >
          <Typography variant="h6" style={{marginBottom: "20px"}}>
            Create new class
          </Typography>



    {formik.values.classType === "one_to_one" ? <></> : <>
          <div className="relative w-full" style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'space-between'}}>
            <div style={{ flexBasis: '45%' }}> 

              <TextField
                id="classStartDate"
                name="classStartDate"
                label="Class Start Date"
                type="date"
                style={{paddingRight: '200px'}}
                InputLabelProps={{
                  shrink: true,
                }}
                value={formik.values.classStartDate}
                onChange={formik.handleChange}
                error={formik.touched.classStartDate && Boolean(formik.errors.classStartDate)}
                helperText={formik.touched.classStartDate && formik.errors.classStartDate}
              />
           </div>

          </div>

          <div className="relative w-full" style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'space-between'}}>

            <div style={{ flexBasis: '45%'}}> 
              <LocalizationProvider  dateAdapter={AdapterDateFns}>
                <TimePicker
                    id="startTime"
                    name="startTime"
                    label="Class Start Time (12 hour clock format)"
                    value={formik.values.startTime}
                    onChange={(value) => formik.setFieldValue('startTime', value)}
                    renderInput={(params) => (
                      <TextField 
                        style={{width: '340px'}} 
                        error={formik.touched.startTime && Boolean(formik.errors.startTime)}
                        helperText={formik.touched.startTime && formik.errors.startTime}
                        {...params} 
                      />)}
                  />
              </LocalizationProvider>
            </div>

            <div style={{ flexBasis: '45%' }}> 
              <TextField
                label="Class Duration (Minutes)"
                id="classDurationMins"
                name="classDurationMins"
                type="number"
                value={formik.values.classDurationMins}
                onChange={formik.handleChange}
                error={formik.touched.classDurationMins && Boolean(formik.errors.classDurationMins)}
                helperText={formik.touched.classDurationMins && formik.errors.classDurationMins}  
                inputProps={{
                  min: 1, // Ensures the input is a positive number
                  onInput: (e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                  }
                }}
              />
            </div>
          </div>
          </>}

          <div className="relative w-full" style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'space-between'}}>

          <div style={{ flexBasis: '45%' }}>
          <FormControl fullWidth>
            <InputLabel id="subject">Subject</InputLabel>
            <Select
              labelId="subject"
              id="subject"
              name="subject"
              value={formik.values.subject}
              onChange={formik.handleChange}
              fullWidth
              error={formik.touched.subject && Boolean(formik.errors.subject)}
            >
              {CONSTANTS.TLHSubjects.map((subject, index) => (
                <MenuItem key={index} value={subject.toLowerCase()}>
                  {subject.charAt(0).toUpperCase() + subject.slice(1).toLowerCase()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </div>

          <div style={{ flexBasis: '45%' }}>
            <FormControl fullWidth>
              <InputLabel id="roomNumber">Room Number</InputLabel>
              <Select
                labelId="roomNumber"
                id="roomNumber"
                name="roomNumber"
                value={formik.values.roomNumber}
                onChange={formik.handleChange}
                error={formik.touched.roomNumber && Boolean(formik.errors.roomNumber)}
              >
                {CONSTANTS.TLHRooms.map((room, index) => (
                  <MenuItem key={index} value={room.toLowerCase()}>
                    {room.replace(/_/g, " ")}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          </div>

          <div className="relative w-full" style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'space-between'}}>

            <FormControl fullWidth style={{ maxWidth: '250px', paddingBottom: '20px' }}>
              <InputLabel id="yearGroup">Level</InputLabel>
              <Select
                labelId="yearGroup"
                id="yearGroup"
                name="yearGroup"
                value={formik.values.yearGroup}
                onChange={formik.handleChange}
                fullWidth
                error={formik.touched.yearGroup && Boolean(formik.errors.yearGroup)}
              >
                {CONSTANTS.TLHYearGroups.map((subject, index) => (
                  <MenuItem key={index} value={subject.toLowerCase()}>
                    {subject.replace("_", " ")}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

          </div>

    
          <FormControl fullWidth style={{paddingBottom: "20px"}}> 
            <InputLabel id="classType">Class Type</InputLabel>
            <Select
              labelId="classType"
              id="classType"
              name="classType"
              value={formik.values.classType}
              onChange={formik.handleChange}
              fullWidth
              error={formik.touched.classType && Boolean(formik.errors.classType)}
            >
              <MenuItem value="holiday_workshop">Holiday Workshop</MenuItem>
              <MenuItem value="weekly_class">Weekly Class</MenuItem>
              <MenuItem value="one_to_one">1 to 1</MenuItem>
              <MenuItem value="booster_class">Booster Class</MenuItem>
            </Select>
          </FormControl>


          {formik.values.classType === "holiday_workshop" || formik.values.classType === "booster_class" ? 
            <div style={{ flexBasis: '45%' }}> 

              <TextField
                id="classEndDate"
                name="classEndDate"
                label="Date of Last Class"
                type="date"
                fullWidth
                style={{paddingRight: '200px'}}
                InputLabelProps={{
                  shrink: true,
                }}
                value={formik.values.classEndDate}
                onChange={formik.handleChange}
                error={(formik.values.classType === "holiday_workshop" || formik.values.classType === "booster_class") && formik.touched.classEndDate && Boolean(formik.errors.classEndDate)}
                helperText={formik.touched.classEndDate && formik.errors.classEndDate}
              />
            </div>

            : <></>}

  {formik.values.classType === "one_to_one" && (
  <div className="w-full" style={{ paddingBottom: '20px' }}>
    <h4>Scheduled Lessons</h4>

    {(formik.values.lessons || []).map((lesson, index) => (
      <div
        key={index}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
          alignItems: 'center',
        }}
      >
        <TextField
          label="Date"
          type="date"
          name={`lessons[${index}].date`}
          value={lesson.date}
          onChange={formik.handleChange}
          InputLabelProps={{ shrink: true }}
          style={{ width: '30%' }}
        />
        {/* Auto-prefill new lesson rows' time and duration from the first lesson */}
        {index > 0 && formik.values.lessons && formik.values.lessons[0] && (() => {
          const first = formik.values.lessons[0];
          const needsPrefill = (!lesson.time && !lesson.duration) || (lesson.time === '' && lesson.duration === '');
          if (needsPrefill && (first.time || first.duration)) {
            const updated = [...formik.values.lessons];
            // Only update if values differ to avoid infinite loops
            if (updated[index].time !== (first.time || '') || updated[index].duration !== (first.duration || '')) {
              updated[index] = { ...updated[index], time: first.time || '', duration: first.duration || '' };
              // defer to avoid state update during render
              setTimeout(() => formik.setFieldValue('lessons', updated), 0);
            }
          }
          return null;
        })()}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimePicker
            label="Time"
            name={`lessons[${index}].time`}
            value={(() => {
              if (!lesson.time) return null;
              const [h, m] = lesson.time.split(':').map(Number);
              if (isNaN(h) || isNaN(m)) return null;
              const d = new Date();
              d.setHours(h, m, 0, 0);
              return d;
            })()}
            onChange={(value) => {
              const timeString = value
                ? String(value.getHours()).padStart(2, '0') + ':' + String(value.getMinutes()).padStart(2, '0')
                : '';
              formik.setFieldValue(`lessons[${index}].time`, timeString);
            }}
            renderInput={(params) => (
              <TextField
          {...params}
          style={{ width: '30%' }}
          error={formik.touched.lessons?.[index]?.time && Boolean(formik.errors.lessons?.[index]?.time)}
          helperText={formik.touched.lessons?.[index]?.time && formik.errors.lessons?.[index]?.time}
              />
            )}
          />
        </LocalizationProvider>

        <TextField
          label="Duration (minutes)"
          type="number"
          name={`lessons[${index}].duration`}
          value={lesson.duration}
          onChange={formik.handleChange}
          style={{ width: '30%' }}
          inputProps={{ min: 1 }}
        />

        <button
          type="button"
          onClick={() => {
            const updatedLessons = [...formik.values.lessons];
            updatedLessons.splice(index, 1);
            formik.setFieldValue('lessons', updatedLessons);
          }}
          style={{ marginLeft: '10px' }}
        >
          ❌
        </button>
      </div>
    ))}

    <button
      type="button"
      onClick={() => {
        const lessons = formik.values.lessons || [];
        const prev = lessons.length > 0 ? lessons[lessons.length - 1] : null;

        let nextDate = '';
        if (prev?.date) {
          const d = new Date(prev.date);
          d.setDate(d.getDate() + 7);
          nextDate = d.toISOString().split('T')[0];
        }

        formik.setFieldValue('lessons', [
          ...lessons,
          { date: nextDate, time: prev?.time || '', duration: prev?.duration || '' }
        ]);
        setLessonsError('');
      }}
    >
      ➕ Add Lesson
    </button>

    {/* Running Total Display */}
    {(() => {
      const totalMinutes = (formik.values.lessons || []).reduce((sum, lesson) => {
        const mins = parseInt(lesson.duration, 10);
        return sum + (isNaN(mins) ? 0 : mins);
      }, 0);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return (
        <div style={{
          marginTop: '16px',
          padding: '12px 16px',
          background: '#e8f4fd',
          borderRadius: '8px',
          border: '1px solid #90caf9',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <span style={{ fontSize: '13px', color: '#1565c0', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Total Time Booked
          </span>
          <span style={{ fontSize: '20px', fontWeight: 700, color: '#0d47a1' }}>
            {hours}h {minutes}m
          </span>
        </div>
      );
    })()}
    {lessonsError && (
      <FormHelperText error style={{ fontSize: '13px', marginTop: '8px' }}>
        {lessonsError}
      </FormHelperText>
    )}
      </div>
    )}

    {/* One-to-one student selectors */}
    {formik.values.classType === "one_to_one" && (() => {
      function OneToOneInputs() {
        const [currentOpenEnquiriesStudents, setCurrentOpenEnquiriesStudents] = useState("");
        const [currentTLHStudents, setCurrentTLHStudents] = useState('');
        const [suggestionsFromNewEnquires, setSuggestionsFromNewEnquiries] = useState([]);
        const [suggestionsFromCurrentTLHStudents, setSuggestionsFromCurrentTLHStudents] = useState([]);
        const debounceRef = useRef(null);


        useEffect(() => {
          // console.log("Cleaning up debounce on unmount");
          return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
          };
        }, []);

        const fetchAndSet = (query, setSuggestions, isSearchingNewStudents) => {
          if (!query || query.trim().length === 0) {
            setSuggestions([]);
            return;
          }
          
          console.log("Forming values are:");
          console.log(formik.values);
          console.log("Current open enquiries student:", currentOpenEnquiriesStudents);
          const studentType = isSearchingNewStudents ? "current_open_enquiry" : "current_tlh_student";

          TLHClassesAPICalls.getMatchingOneToOneStudents(studentType, query)
            .then(res => {
              const data = res.data || [];
              console.log("Fetched student suggestions:", res);
              console.log(res.data);
              data.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
              setSuggestions(data);
            })
            .catch(() => {
              setSuggestions([]);
            });
        };

        function handleCurrentOpenEnquiriesStudents(val) {
          if (val == "") {
            formik.setFieldValue('studentName', "");
          }
          setCurrentOpenEnquiriesStudents(val);
          if (currentTLHStudents !== '') {
            setCurrentTLHStudents('');
            formik.setFieldValue('oneToOneCurrentTLHStudentId', '');
            setSuggestionsFromCurrentTLHStudents([]);
          }
          if (debounceRef.current) clearTimeout(debounceRef.current);
          debounceRef.current = setTimeout(() => fetchAndSet(val, setSuggestionsFromNewEnquiries, true), 300);
        }

        const handleCurrentTLHStudents = (val) => {
          if (val == "") {
            formik.setFieldValue('tlhStudentName', "");
          }
          setCurrentTLHStudents(val);
          if (currentOpenEnquiriesStudents !== '') {
            setCurrentOpenEnquiriesStudents('');
            formik.setFieldValue('oneToOneStudentCurrentOpenEnquiryId', '');
            setSuggestionsFromNewEnquiries([]);
          }
          if (debounceRef.current) clearTimeout(debounceRef.current);
          debounceRef.current = setTimeout(() => fetchAndSet(val, setSuggestionsFromCurrentTLHStudents, false), 300);
        };

        const pickCurrentOpenEnquiryStudent = (student) => {
          const fullName = [student?.studentFirstName?.trim(), student?.studentSurname?.trim()].filter(Boolean).join(' ');
          formik.setFieldValue('studentName', fullName);
          setCurrentOpenEnquiriesStudents(fullName);
          setSuggestionsFromNewEnquiries([]);
          formik.setFieldValue('oneToOneStudentCurrentOpenEnquiryId', student.assessmentStudentId);
          // ensure other box cleared
          formik.setFieldValue('tlhStudentName', "");
          setCurrentTLHStudents('');
          setSuggestionsFromCurrentTLHStudents([]);
          formik.setFieldValue('oneToOneCurrentTLHStudentId', '');
          console.log("Formik values as of now: for current open enquiry")
          console.log(formik.values)
        };

        const pickCurrentTLHStudent = (student) => {
          const fullName = [student?.firstName?.trim(), student?.surname?.trim()].filter(Boolean).join(' ');
          formik.setFieldValue('tlhStudentName', fullName);
          setCurrentTLHStudents(fullName);
          setSuggestionsFromCurrentTLHStudents([]);
          formik.setFieldValue('oneToOneCurrentTLHStudentId', student.tlhStudentId);
          // ensure other box cleared
          formik.setFieldValue('studentName', "");
          setSuggestionsFromNewEnquiries([]);
          formik.setFieldValue('oneToOneStudentCurrentOpenEnquiryId', '');
          console.log("Formik values as of now:")
          console.log(formik.values)
        };

        return (
          <div style={{ paddingBottom: '20px' }}>
            <Typography variant="subtitle1" style={{ marginBottom: '8px' }}>
              One-to-one student (choose one of two)
            </Typography>

            <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>

              <div style={{ flex: 1, position: 'relative' }}>
                <TextField
                  label="New Open Enquiry Student"
                  // value={currentOpenEnquiriesStudents}
                  value={currentOpenEnquiriesStudents === '' ? formik.values.studentName : currentOpenEnquiriesStudents }
                  onChange={(e) => handleCurrentOpenEnquiriesStudents(e.target.value)}
                  fullWidth
                  autoComplete="off"
                />
                {suggestionsFromNewEnquires.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    zIndex: 999,
                    background: 'white',
                    border: '1px solid rgba(0,0,0,0.12)',
                    width: '100%',
                    maxHeight: 200,
                    overflowY: 'auto'
                  }}>
                    {suggestionsFromNewEnquires.map((s) => (
                      <div
                        key={s.assessmentStudentId}
                        onMouseDown={() => pickCurrentOpenEnquiryStudent(s)}
                        style={{ padding: '8px', cursor: 'pointer' }}
                      >
                        {s.studentFirstName} {s.studentSurname} 
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div style={{ flex: 1, position: 'relative' }}>
                <TextField
                  label="Current TLH Student"
                  value={currentTLHStudents == '' ? formik.values.tlhStudentName : currentTLHStudents}
                  onChange={(e) => handleCurrentTLHStudents(e.target.value)}
                  fullWidth
                  autoComplete="off"
                />
                {suggestionsFromCurrentTLHStudents.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    zIndex: 999,
                    background: 'white',
                    border: '1px solid rgba(0,0,0,0.12)',
                    width: '100%',
                    maxHeight: 200,
                    overflowY: 'auto'
                  }}>
                    {suggestionsFromCurrentTLHStudents.map((s) => (
                      <div
                        key={s.studentId}
                        onMouseDown={(ev) => { ev.preventDefault(); pickCurrentTLHStudent(s); }}
                        style={{ padding: '8px', cursor: 'pointer' }}
                      >
                        {s.firstName} {s.surname}
                      </div>
                    ))}
                  </div>
                )}
              </div>

            </div>

            <div style={{ marginTop: '8px', color: '#555', fontSize: '13px' }}>
              Only one of the boxes may contain a selected student at a time. Selected IDs are stored for submission.
            </div>
          </div>
        );
      }

      return <OneToOneInputs />;
    })()}

    {formik.values.classType === "one_to_one" && (
      <FormControl fullWidth style={{ paddingBottom: '20px' }}>
        <InputLabel id="relatedClasses">Related One-to-One Classes</InputLabel>
        <Select
          labelId="relatedClasses"
          id="relatedClasses"
          name="relatedClasses"
          multiple
          value={formik.values.relatedClasses}
          onChange={formik.handleChange}
          renderValue={(selected) => selected.map(id => tlhOneToOneLessons.find(l => l.classId === id)?.className).join(', ')}
        >
          {tlhOneToOneLessons.map((lesson) => (
            <MenuItem key={lesson.classId} value={lesson.classId}>
              {lesson.className}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}

    {formik.values.classType !== "one_to_one" && (
      <>
        <FormControl fullWidth style={{ paddingBottom: '20px' }}>
      <InputLabel id="relatedClasses">Related Classes</InputLabel>
      <Select
        labelId="relatedClasses"
        id="relatedClasses"
        name="relatedClasses"
        multiple
        value={formik.values.relatedClasses}
        onChange={formik.handleChange}
        renderValue={(selected) => selected.map(id => tlhLessons.find(lesson => lesson.classId === id)?.className).join(', ')}
        error={formik.touched.relatedClasses && Boolean(formik.errors.relatedClasses)}
      >
        {tlhLessons.map((lesson) => (
          <MenuItem key={lesson.classId} value={lesson.classId}>
        {lesson.className}
          </MenuItem>
        ))}
      </Select>
        </FormControl>

        <Typography>
      Is this class a duplicate of any existing classes (same lesson material but running at different times)
        </Typography>

        <FormControl fullWidth style={{ paddingBottom: '20px' }}>
      <InputLabel id="duplicateClasses">Duplicate Classes</InputLabel>
      <Select
        labelId="duplicateClasses"
        id="duplicateClasses"
        name="duplicateClasses"
        multiple
        value={formik.values.duplicateClasses}
        onChange={formik.handleChange}
        renderValue={(selected) => selected.map(id => tlhLessons.find(lesson => lesson.classId === id)?.className).join(', ')}
        error={formik.touched.duplicateClasses && Boolean(formik.errors.duplicateClasses)}
      >
        {tlhLessons.map((lesson) => (
          <MenuItem key={lesson.classId} value={lesson.classId}>
        {lesson.className}
          </MenuItem>
        ))}
      </Select>
        </FormControl>
        </>
 )}
        <div style={{textAlign: "center", paddingTop: "25px"}}>
      <button 
          style={{
        padding: '10px 20px',
        fontSize: '18px',
        color: 'white',
        backgroundColor: '#0056b3',
        border: 'none',
        borderRadius: '5px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        }}
        onMouseOver={(e) => {
        e.target.style.backgroundColor = '#004085';
        e.target.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
        }}
        onMouseOut={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
        }}
        type="button"
        onClick={async () => {
          const errors = await formik.validateForm();
          if (Object.keys(errors).length > 0) {
            formik.setTouched(
              Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
            );
            return;
          }
          if (formik.values.classType === 'one_to_one' && formik.values.roomNumber === 'online') {
            handleOnlineAccountCheck(formik.values);
          } else {
            formik.submitForm();
          }
        }}
      >
          Create New Class
      </button>
        </div>
      
   
               
      </form>
    }

    {/* Online account confirmation modal */}
    <Modal open={accountCheckModal.open} onClose={() => setAccountCheckModal(m => ({ ...m, open: false }))}>
      <Box sx={{
        position: 'absolute', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper', borderRadius: 2,
        boxShadow: 24, p: 4, width: 420,
      }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Online Account Check</Typography>

        {accountCheckModal.loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 3 }}>
            <CircularProgress size={24} />
            <Typography variant="body2" color="text.secondary">Checking for existing account...</Typography>
          </Box>
        ) : (
          <>
            <Alert severity="info" sx={{ mb: 2 }}>
              The email address <strong>{accountCheckModal.email}</strong> is already associated with another student. A new unique account will be created for this student instead.
            </Alert>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <Button onClick={() => setAccountCheckModal(m => ({ ...m, open: false }))}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setAccountCheckModal(m => ({ ...m, open: false }));
                  formik.submitForm();
                }}
              >
                OK, proceed
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>

    </div>

  );
}
